// extracted by mini-css-extract-plugin
export var bounce = "_p2-1";
export var generatingText = "_p2-6";
export var lightning = "_p2-4";
export var popup = "_p2-5";
export var progressBar = "_p2-7";
export var progressFill = "_p2-8";
export var progressShimmer = "_p2-9";
export var progressText = "_p2-a";
export var shimmer = "_p2-3";
export var uploadIcon = "_p2-0";
export var uploadingText = "_p2-2";